import { preloadImage } from "utils/helpers";

import home_1 from "./home-1.jpg";
import home_1_webp from "./home-1.webp";
import home_2 from "./home-2.jpg";
import home_2_webp from "./home-2.webp";
import home_3 from "./home-3.jpg";
import home_3_webp from "./home-3.webp";
import home_4 from "./home-4.jpg";
import home_4_webp from "./home-4.webp";
import logo from "./logo.png";
import logo_webp from "./logo.webp";
import custom_email_template from "./mail-template.png";
import not_found from "./not-found.jpg";
import not_found_webp from "./not-found.webp";
import PTPLogo from "./PTPLogo.svg";

export const IMAGES = {
  logo: { jpg: logo, webp: logo_webp },
  home_1: { jpg: home_1, webp: home_1_webp },
  home_2: { jpg: home_2, webp: home_2_webp },
  home_3: { jpg: home_3, webp: home_3_webp },
  home_4: { jpg: home_4, webp: home_4_webp },
  not_found: { jpg: not_found, webp: not_found_webp },
  PTPLogo,
  custom_email_template,
};

[home_1, home_2, home_3, home_4, not_found, logo, PTPLogo, custom_email_template].forEach((value) =>
  preloadImage(value)
);
